import React, { Fragment, useImperativeHandle, useState } from 'react'
import { createPortal } from 'react-dom'
import { Card, CardBody, Button } from 'reactstrap'
//************************************//
import { trans } from '@utils'
//************************************//
const SlimModalPopup = React.forwardRef((props, ref) => {
  const open = _.get(props, 'open', false)
  const [modal, setModal] = useState({ open, args: {} })
  const portal = _.get(props, 'portal', null)

  const getModalContentStyle = () => {
    const style = {}
    if (props.maxWidth) {
      style.maxWidth = props.maxWidth
    }
    return style
  }

  useImperativeHandle(ref, () => ({
    open: (args = {}) => {
      setModal({ open: true, args })
    },
    close: () => {
      setModal({ open: false, args: {} })
    }
  }))

  if (!modal.open) {
    return null
  }

  const content = (
    <Fragment>
      <div className='slim-modal-popup-overlay'></div>
      <div className='slim-modal-popup-wapper'>
        <div className="slim-modal-popup-inner px-2 pb-3">
          <Card className="slim-modal-popup-content mb-0" style={getModalContentStyle()}>
            <CardBody className={'pb-75'}>
              {_.isFunction(props.children) ? props.children(modal.args) : props.children}
            </CardBody>
          </Card>
        </div>
      </div>
    </Fragment>
  )

  return portal ? createPortal(content, portal) : content
})

SlimModalPopup.propTypes = {}

export default SlimModalPopup
